import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CallAppointmentHistoryComponent } from '../../call-appointment-history/call-appointment-history.component';
import { CallCenterComponent } from '../../call-center/call-center.component';
import { CallCenterInboundCallComponent } from '../call-center-inbound-call.component';


const routes: Routes = [
  {
    path : "",
    component : CallCenterComponent 
   },
  {
    path : "",
    component : CallCenterInboundCallComponent
  },
  {
    path: 'view-history',
    component : CallAppointmentHistoryComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CallCenterInboundCallRoutingModule { }
